import { ImpactCo2Gateway } from '@/domain/impact-co2/gateways/impact-co2.gateway';

import { importImpactAnswers } from './import-impact-answers/import-impact-answers';
import { deleteImpactAnswer } from './questions/delete-impact-answer';
import { getImpactAnswers } from './questions/get-impact-answers';
import { getImpactAnswersForCategory } from './questions/get-impact-answers-for-category';
import { submitImpactAnswer } from './questions/submit-impact-answer';

export class ApiImpactCo2HttpGateway implements ImpactCo2Gateway {
  getImpactAnswers = getImpactAnswers;
  getImpactAnswersForCategory = getImpactAnswersForCategory;
  submitImpactAnswer = submitImpactAnswer;
  deleteImpactAnswer = deleteImpactAnswer;
  importImpactAnswers = importImpactAnswers;
}
